var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "print-personal-account" }, [
    _c(
      "div",
      { staticClass: "print-personal-account__container" },
      [
        _c("div", { staticClass: "print-personal-account__employee" }, [
          _vm._v("Расчётный лист " + _vm._s(_vm.employeeName)),
        ]),
        _vm.period
          ? _c("div", { staticClass: "print-personal-account__period" }, [
              _vm._v(" " + _vm._s(_vm.period) + " "),
            ])
          : _vm._e(),
        _c("operations-table", {
          staticClass: "print-personal-account__table",
          attrs: {
            operations: _vm.operations,
            columns: _vm.columns,
            print: false,
          },
        }),
        _c("div", { staticClass: "print-personal-account__total" }, [
          _vm._v(" ИТОГО К ВЫПЛАТЕ: "),
          _c("span", { staticClass: "total" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.total.toLocaleString("ru-RU", {
                    style: "currency",
                    currency: "RUB",
                  })
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "print-personal-account__sign" }, [
          _vm._v("(" + _vm._s(_vm.employeeName) + ")"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }